module.exports = __webpack_public_path__ + "static/media/caterpillar-logo.349de75c.png";